import React from 'react'
import ButtonList from './ButtonList'
import VideoContainer from './VideoContainer'

function Maincontainer() {
  return (
    <div className='m-2'>
    <ButtonList />
    <VideoContainer/>
    </div>
  )
}

export default Maincontainer